import { applyMask, undoMask } from '@lemonade-hq/ts-helpers';
import { useCallback } from 'react';

// eslint-disable-next-line functional/prefer-readonly-type
function useMaskedValue(param) {
    var value = param.value, mask = param.mask, onChange = param.onChange;
    var maskedValue = mask != null && value != null ? applyMask(mask, value) : value;
    var onChangeWithMask = useCallback(function(e) {
        if (onChange != null) {
            e.target.value = mask != null ? undoMask(mask, e.target.value) : e.target.value;
            onChange(e);
        }
    }, [
        onChange,
        mask
    ]);
    return {
        maskedValue: maskedValue,
        onChangeWithMask: onChangeWithMask
    };
}

export { useMaskedValue };
